const SET_OPEN = `SET_OPEN@${__filename}`;

const initialState = {
  isOpen: false,
};

export function setOpen(isOpen) {
  return {
    type: SET_OPEN,
    isOpen,
  };
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_OPEN:
      return { ...state, isOpen: action.isOpen };
    default:
      return state;
  }
}
